import { useState } from 'react'
import Joyride, { ACTIONS, EVENTS, STATUS, Step } from 'react-joyride'
import Tooltip from './Tooltip'

const steps: Array<Step> = [
  {
    target: 'body',
    placement: 'center',
    hideCloseButton: true,
    title: 'Integration Settings',
    content: 'In this tour, you will be shown the Clio integration settings'
  },
  {
    target: '#organization-default-radio',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Organization Default',
    content:
      'Sets your account to the default settings of your organization, which can be set by an admin user. (listed in the left column below)'
  },
  {
    target: '#account-default-radio',
    placement: 'auto',
    hideCloseButton: true,
    title: 'My Account Default',
    content:
      'Gives you the ability to personalize the default settings in your account. (listed in the right column below)'
  },
  {
    target: '#inbound-sms-box',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Inbound SMS Rates',
    content:
      'Calculate the duration of your inbound messages. (measured in hours, where 1 = one hour and 0.5 = half an hour)'
  },
  {
    target: '#outbound-sms-box',
    placement: 'auto',
    hideCloseButton: true,
    title: 'Outbound SMS Rates',
    content:
      'Calculate the duration of your outbound messages. (measured in hours, where 1 = one hour and 0.5 = half an hour)'
  }
]

const IntegrationSettingsTour = ({ run, setRun }) => {
  const [step, setStep] = useState(0)

  const handleJoyrideCallBack = async (data) => {
    const { action, index, status, type } = data

    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setStep(0)
      setRun('integration', false)

      return
    }

    if (EVENTS.TARGET_NOT_FOUND === type) {
      setStep(index - 1)
      setRun('integration', true)

      return
    }

    if (EVENTS.STEP_AFTER === type) {
      const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1)

      setStep(stepIndex)
    }
  }

  return (
    <Joyride
      steps={steps}
      stepIndex={step}
      run={run}
      continuous
      showSkipButton
      scrollOffset={100}
      disableCloseOnEsc
      disableOverlayClose
      callback={handleJoyrideCallBack}
      tooltipComponent={Tooltip}
      spotlightPadding={0}
      styles={{
        tooltipContainer: { display: 'flex', justifyContent: 'center' },
        options: {
          zIndex: 4000
        }
      }}
    />
  )
}

export default IntegrationSettingsTour
